<template>
  <div class="overflow-hidden">
    <label class="form-label d-block" v-if="model.vars.label">{{ model.vars.label }}</label>
    <div :class="'fakeModel__image ' + (isCluster ? '-cluster' : '')">
      <img
        v-if="isEditorType()"
        :src="'/assets/images/models/tinymce-' + responsivePrefix + i18n.global.locale + '.webp'"
        alt="fakeModel"
      />
    </div>
  </div>
</template>

<script>
import { formManager } from "@/services/form/form-manager";
import { i18n } from "@/i18n";

export default {
  name: "FakeModelComponent",
  components: {},
  props: {
    model: {
      type: Object,
      required: true,
    },
    isCluster: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      responsivePrefix: "",
    };
  },
  computed: {
    i18n() {
      return i18n;
    },
  },
  mounted() {
    window.addEventListener("resize", this.setResponsivePrefix);
    this.setResponsivePrefix();
  },
  unmounted() {
    window.removeEventListener("resize", this.setResponsivePrefix);
  },
  methods: {
    isEditorType() {
      return formManager.isEditorType(this.model);
    },
    setResponsivePrefix() {
      if (!this.isCluster) {
        if (window.innerWidth < 400) {
          this.responsivePrefix = "mobile-";
        } else if (window.innerWidth > 400 && window.innerWidth < 576) {
          this.responsivePrefix = "tablet-";
        } else {
          this.responsivePrefix = "";
        }
      } else {
        if (
          (window.innerWidth >= 1000 && window.innerWidth < 1400) ||
          (window.innerWidth < 550 && window.innerWidth > 400)
        ) {
          this.responsivePrefix = "cluster-tablet-";
        } else if ((window.innerWidth >= 768 && window.innerWidth < 1000) || window.innerWidth <= 400) {
          this.responsivePrefix = "cluster-mobile-";
        } else {
          this.responsivePrefix = "cluster-";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fakeModel {
  &__image {
    border: 1px solid #cccccc;
    border-radius: 5px;
    overflow: hidden;
    img {
      width: 100%;
      @media (max-width: 1900px) {
        width: auto;
      }
      @include mobile {
        width: 100%;
      }
    }

    &.-cluster {
      width: 100%;
      img {
        @media (max-width: 1900px) {
          width: 100%;
        }
      }
    }
  }
}
</style>
